
<template>
  <div>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'RouterLink',
  components: {  },
  props: {
  },
};
</script>
<style lang='scss' scoped>

</style>
